import { Actions } from '../actions/fetchClientOverridesCount';
import { DeepReadonly } from 'utility-types';

export type State = DeepReadonly<{
  clientOverridesCount: number | null;
}>;

export const initialState: State = {
  clientOverridesCount: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_CLIENT_OVERRIDES_COUNT_SUCCESS':
      return {
        clientOverridesCount: action.payload
      };
    default:
      return state;
  }
}
